export default __webpack_public_path__ + "static/media/logo_gerdau_blue_horizontal.c2b468cb.svg";